import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FaFacebookF, FaEye, FaEyeSlash } from "react-icons/fa";
import { FiInfo } from "react-icons/fi";
import logo from "../assets/svg.png";
import { useAPI } from "../Context/MyContext";
import FacebookLogin from "../Login/FacebookLogin";
import { Helmet } from 'react-helmet-async';
import chatFavicon from "../assets/favicon/favicon.ico";


// Logo placeholder
const LogoPlaceholder = () => (
  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center">
    <span className="text-white font-bold text-2xl">W</span>
  </div>
);



// Simple Checkbox component
const Checkbox = ({ id, checked, onCheckedChange, className }) => (
  <div className="relative flex items-center justify-cente  r">
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={(e) => onCheckedChange(e.target.checked)}
      className={`
        appearance-none h-5 w-5 border-2 border-green-600 rounded-full  
        cursor-pointer transition-all duration-200
        checked:bg-green-600 checked:border-green-600
        focus:ring-2 focus:ring-green-300 focus:outline-none
        relative
        before:absolute before:w-[6px] before:h-[10px]
        before:border-r-[2px] before:border-b-[2px] before:border-white
        before:rotate-45 before:top-[2px] before:left-[5px]
        checked:before:opacity-100 before:opacity-0
        ${className}
      `}
    />
  </div>
);

// Simple Label component
const Label = ({ htmlFor, children, className }) => (
  <label htmlFor={htmlFor} className={className}>
    {children}
  </label>
);

// OTP Modal Component
const OTPModal = ({ isOpen, onClose, email, onVerify, onResendOtp }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);




  const handleChange = (index, value) => {
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, 6);
    const newOtp = [...otp];

    for (let i = 0; i < pastedData.length; i++) {
      if (i < 6 && /^\d$/.test(pastedData[i])) {
        newOtp[i] = pastedData[i];
      }
    }
    setOtp(newOtp);
  };

  const handleVerify = () => {
    const otpValue = otp.join("");
    if (otpValue.length === 6) {
      onVerify(otpValue);
    } else {
      toast.error("Please enter all 6 digits", {
        position: "bottom-right",
        autoClose: 3000,
        theme: "dark",
      });
    }
  };

  const handleResend = () => {
    onResendOtp()
    toast.success("OTP resent successfully!", {
      position: "bottom-right",
      autoClose: 3000,
      theme: "dark",
      style: {
        backgroundColor: "#1f2937",
        color: "#fff",
      },
    });
    setOtp(["", "", "", "", "", ""]);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Verify Your Email</h2>
          <p className="text-gray-600 text-sm">
            We've sent a 6-digit code to{" "}
            <span className="font-semibold text-gray-800">{email}</span>
          </p>
        </div>

        <div className="flex justify-center gap-3 mb-8" onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className="w-12 h-14 text-center text-2xl font-semibold border-2 border-gray-300 rounded-lg focus:border-green-500 focus:ring-2 focus:ring-green-200 outline-none transition"
            />
          ))}
        </div>

        <button
          onClick={handleVerify}
          className="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-3.5 rounded-lg transition duration-200 shadow-lg hover:shadow-xl mb-4"
        >
          Verify & Create Account
        </button>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            Didn't receive the code?{" "}
            <button
              onClick={handleResend}
              className="text-green-600 hover:text-green-700 font-semibold"
            >
              Resend
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const { Register, verifyOtpAbndRegister, resendOtpOnRegister } = useAPI();
  const [phoneNumber, setPhoneNumber] = useState("");

  const navigate = useNavigate();

  const [countryData, setCountryData] = useState({
    dialCode: "92",
    countryCode: "pk",
  });

  const rules = [
    { label: "At least 8 characters", test: /.{8,}/ },
    { label: "One uppercase letter (A–Z)", test: /[A-Z]/ },
    { label: "One lowercase letter (a–z)", test: /[a-z]/ },
    { label: "One number (0–9)", test: /\d/ },
    { label: "One special character (#?!@$%^&*-)", test: /[#?!@$%^&*-]/ },
  ];



  const handleRegister = async (e) => {
    e.preventDefault();

    if (!acceptTerms) {
      toast.error("Please accept the terms and conditions", {
        position: "top-right",
        autoClose: 3000,
        theme: "dark",
        style: {
          backgroundColor: "#1f2937",
          color: "#fff",
        },
      });
      return;
    }

    if (emailError) {
      toast.error("Please fix the email before continuing.", {
        position: "bottom-right",
        autoClose: 3000,
        theme: "dark",
        style: {
          backgroundColor: "#1f2937",
          color: "#fff",
        },
      });
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!", {
        position: "bottom-right",
        autoClose: 3000,
        theme: "dark",
        style: {
          backgroundColor: "#1f2937",
          color: "#fff",
        },
      });
      return;
    }




    try {
      const fullPhone = `${countryData.dialCode}${phone}`;
      const response = await Register({
        name,
        email,
        phone: fullPhone,
        password,
        confirmPassword,
        acceptTerms,
        // country: countryData,
      });
      // console.log("response in registerition", response)
      if (response.success) {
        toast.success(response.message, {
          position: "top-right",
          autoClose: 2000,
          theme: "colored",
        });
        setShowOTPModal(true);
        // navigate("/");
      } else {
        toast.error(response.message || "Registration failed.", {
          position: "top-right",
          autoClose: 2500,
          theme: "colored",
        });
      }
    } catch (error) {


      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong. Please try again."
      );
    }


  };


  const handleVerifyOTP = async (otp) => {
    // console.log("Verifying OTP:", otp, email);


    try {


      const response = await verifyOtpAbndRegister({
        otp,
        email
      });
      // console.log("response in registerition", response)
      if (response.success) {
        toast.success(response.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "dark",
          style: {
            backgroundColor: "#1f2937",
            color: "#fff",
          },
        });
        setTimeout(() => {
          setShowOTPModal(false);
          navigate("/");
        }, 1000);

      } else {
        toast.error(response.message || "Registration failed.", {
          position: "top-right",
          autoClose: 2500,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong. Please try again."
      );
    }

  };
  const handleResendOTP = async () => {
    // console.log("Verifying OTP resend:", email);


    try {


      const response = await resendOtpOnRegister({

        email
      });
      // console.log("response in registerition", response)
      if (response.success) {
        toast.success(response.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "dark",
          style: {
            backgroundColor: "#1f2937",
            color: "#fff",
          },
        });


      } else {
        toast.error(response.message || "Registration failed.", {
          position: "top-right",
          autoClose: 2500,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong. Please try again."
      );
    }

  };



  return (
    <>
      <Helmet>
        <title>Dashboard | WhatGrowPro</title>
        <meta
          name="description"
          content="Manage real-time customer conversations using WhatGrowPro’s Live Chat — connect instantly and improve customer satisfaction."
        />
        <meta name="keywords" content="Live Chat, WhatsApp automation, customer support, WhatGrowPro" />
        <link rel="icon" type="image/png" href={chatFavicon} />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-green-50 flex items-center justify-center p-4 animate-slide-up">
        <ToastContainer />

        <div className="w-full max-w-7xl grid lg:grid-cols-2 gap-8  items-center">
          <div className="hidden lg:flex flex-col justify-center space-y-6 px-8">
            <div className="flex items-center space-x-3 ">
              <img
                src={logo}
                alt="WhatGrowPro Logo"
                className="w-14 h-14 sm:w-16 sm:h-16 md:w-18 md:h-18 lg:w-20 lg:h-20 object-contain -mr-4"
              />
              <div>
                <h1 className="text-xl sm:text-2xl lg:text-2xl font-bold text-gray-800 ">WhatGrowPro</h1>
                <p className="text-xs sm:text-sm text-gray-500">Grow smarter, market faster</p>
              </div>
            </div>

            <h2 className="text-4xl font-bold text-gray-800 leading-tight">
              Start Your WhatsApp Marketing Journey
            </h2>

            <p className="text-gray-600 text-lg">
              Join thousands of businesses using What                                                             GrowPro to reach their customers effectively through WhatsApp Business API.
            </p>

            <div className="space-y-4 pt-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">Automated Campaigns</h3>
                  <p className="text-sm text-gray-600">Send bulk messages with personalization</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">AI-Powered Chatbots</h3>
                  <p className="text-sm text-gray-600">24/7 customer engagement automation</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">Analytics Dashboard</h3>
                  <p className="text-sm text-gray-600">Track and optimize your campaigns</p>
                </div>
              </div>
            </div>
          </div>


          {/*Right side form*/}
          <form onSubmit={handleRegister} className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8">
            <div className="lg:hidden flex items-center justify-center space-x-2 mb-4">
              <LogoPlaceholder />
              <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800">WhatGrowPro</h1>
            </div>

            <div className="mb-6">
              <h3 className="text-2xl font-semibold text-gray-800 mb-1">Create Account</h3>
              <p className="text-gray-600 text-sm">Start your journey with WhatGrowPro</p>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-black mb-1.5">
                  Full Name
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none transition text-sm"
                  placeholder="Enter your full name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-black mb-1.5">
                  Email Address
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEmail(value);
                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (!emailRegex.test(value) && value.length > 0) {
                      setEmailError("Please enter a valid email address.");
                    } else {
                      setEmailError("");
                    }
                  }}
                  required
                  className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:border-transparent outline-none transition text-sm ${emailError
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-green-500"
                    }`}
                  placeholder="Enter your email"
                />
                {emailError && (
                  <p className="text-red-500 text-xs mt-1">{emailError}</p>
                )}
              </div>

              <div className="space-y-1">
                <label className="block text-sm font-medium text-black mb-1.5">
                  Phone Number
                </label>

                <div className="flex styled-phone w-full">

                  <div className="styled-phone flex w-full rounded-lg border border-gray-200 focus-within:ring-2 focus-within:ring-green-500 focus-within:border-transparent transition">

                    {/* Country Selector */}
                    <div className="relative w-[95px]">
                      <PhoneInput
                        country={countryData.countryCode}
                        enableSearch
                        disableCountryCode={false}
                        value={countryData.dialCode}
                        onChange={(value, data) => {
                          setCountryData({
                            dialCode: data.dialCode,
                            countryCode: data.countryCode,
                          });
                        }}
                        inputProps={{ readOnly: true }}
                        containerClass="!w-full"
                        buttonClass="!border-0 !bg-transparent rounded-l-lg !rounded-r-none"
                        dropdownClass="!rounded-xl !shadow-2xl !border !border-gray-200"
                        inputClass="!w-full !h-[42px] !pl-11 !pr-2 !text-sm !text-gray-700 !bg-gray-50 !border-0 rounded-l-lg rounded-r-none"
                      />
                    </div>

                    {/* Phone Number Input */}
                    <div className="relative flex-1">
                      <input
                        type="tel"
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Enter WhatsApp Number"
                        className="w-full h-[42px] pl-4 pr-10 text-sm border-0 rounded-r-lg focus:outline-none transition"
                      />

                      {/* Info Icon */}
                      <div className="absolute inset-y-0 right-3 flex items-center">
                        <div className="relative group/tip">
                          <svg
                            className="w-4 h-4 text-gray-400 hover:text-green-600 transition-colors cursor-pointer"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z"
                            />
                          </svg>

                          {/* Tooltip */}
                          <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 opacity-0 invisible group-hover/tip:opacity-100 group-hover/tip:visible transition-all duration-200 ease-out pointer-events-none z-50">
                            {/* Tooltip Content */}
                            <div className="relative bg-gray-900 rounded-md px-3 py-2 shadow-lg whitespace-nowrap">
                              <p className="text-white text-xs">
                                Please enter a personal WhatsApp number
                              </p>
                              {/* Arrow */}
                              <div className="absolute left-1/2 -translate-x-1/2 -bottom-1 w-2 h-2 bg-gray-900 rotate-45" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>



              <div>
                <label className="block text-sm font-medium text-black mb-1.5">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder="••••••••"
                    className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:border-transparent outline-none transition pr-10 text-sm ${password
                      ? rules.every((r) => r.test.test(password))
                        ? "border-green-500 focus:ring-green-500"
                        : "border-yellow-400 focus:ring-yellow-400"
                      : "border-gray-300 focus:ring-green-500"
                      }`}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none text-sm"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-black mb-1.5">
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    placeholder="••••••••"
                    className={`w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:border-transparent outline-none transition pr-10 text-sm ${confirmPassword && password !== confirmPassword
                      ? "border-red-500 focus:ring-red-500"
                      : "border-gray-300 focus:ring-green-500"
                      }`}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none text-sm"
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {confirmPassword && password !== confirmPassword && (
                  <p className="text-red-500 text-xs mt-1">Passwords do not match</p>
                )}
              </div>

              <div className="flex items-center space-x-2 mt-1">
                <Checkbox
                  id="terms"
                  checked={acceptTerms}
                  onCheckedChange={(checked) => setAcceptTerms(checked)}
                  className="h-4 w-4 rounded-full border-2 border-green-400 checked:bg-green-600 checked:border-green-600 cursor-pointer transition-all duration-200 focus:ring-2 focus:ring-green-400"
                />
                <Label
                  htmlFor="terms"
                  className="text-xs cursor-pointer leading-relaxed"
                >
                  I agree to the{" "}
                  <Link
                    to="/terms"
                    className="text-green-600 hover:text-green-700 font-medium"
                  >
                    Terms of Service
                  </Link>{" "}
                  and{" "}
                  <Link
                    to="/privacy"
                    className="text-green-600 hover:text-green-700 font-medium"
                  >
                    Privacy Policy
                  </Link>
                </Label>
              </div>

              <button
                type="submit"
                className="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-2.5 px-4 rounded-lg transition duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-sm"
              >
                Create Account
              </button>

              {/* <div className="relative my-4">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-4 bg-white text-gray-500 text-xs">Or</span>
              </div>
            </div> */}
              {/* 
            <button
              type="button"
              onClick={() => {
                toast.info("Facebook login coming soon!", {
                  position: "bottom-right",
                  autoClose: 3000,
                  theme: "dark",
                  style: {
                    backgroundColor: "#1f2937",
                    color: "#fff",
                  },
                });
              }}
              className="w-full flex items-center justify-center gap-2 bg-[#1877F2] hover:bg-[#166FE5] text-white font-semibold py-2.5 px-4 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg hover:-translate-y-0.5"
            >
              <div className="flex items-center justify-center w-7 h-7 bg-white/20 rounded-full">
                <FaFacebookF className="text-white text-base" />
              </div>
              <span className="text-white text-sm">Continue with Facebook</span>
            </button> */}


              <FacebookLogin />


              <div className="text-center pt-1">
                <p className="text-gray-600 text-sm">
                  Already have an account?{" "}
                  <Link
                    to="/"
                    className="text-green-600 font-semibold hover:text-green-700 transition cursor-pointer"
                  >
                    Login here
                  </Link>
                </p>
              </div>
            </div>
          </form>
        </div>

        <OTPModal
          isOpen={showOTPModal}
          onClose={() => setShowOTPModal(false)}
          email={email}
          onVerify={handleVerifyOTP}
          onResendOtp={handleResendOTP}
        />
      </div>
    </>
  );
};

export default Register;



// Registration form data: {
//   name: "Haider",
//   email: "haider@gmail.com",
//   phone: "923001234567",
//  dial

//   password: "Test@123",
//   confirmPassword: "Test@123",
//   acceptTerms: true
// }